import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	searchInputContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		padding: theme.spacing(2)
	},
	input: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "3px",
		"& svg": {
			marginLeft: theme.spacing(1)
		},
		"&::before": {
			borderBottom: "none"
		}
	},
	list: {
		overflowY: "scroll",
		height: "100%",
		maxHeight: "calc(100vh - 120px)" // 120px is the sum of the drawerHeader and inputContainer heights
	},
	badgeContainer: {
		width: 22,
		height: 22,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "100%",
		border: `3px solid ${colors.gray[0]}`
	},
	chatDescription: {},
	addContactAvatar: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
	},
	iconButton: {
		padding: "6px"
	},
	newChatTriggerButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[300]),
		borderRadius: "50%",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[400])
		}
	},
	newContactListItem: {
		width: "100%"
	},
	newContactWrapper: {
		width: "100%",
		"& > div": {
			width: "100%"
		}
	}
}))

export default useStyles
